import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import classNames from 'classnames';

import { Menu } from 'semantic-ui-react';

import { SatCoreRegister } from '../SatCoreRegistry';
import { ASSIGNMENT_MENU_STATUS } from '../managers/AssignmentManager';

const StudentAssignmentMenuStatusTabs = observer((props = {}) => {
  const {
    activeMenuStatus,
    loading,
    loadingClassName,
    onClick,
    t
  } = props;

  const { assignmentManager } = useContext(MobXProviderContext);

  const menuStatusOrder = assignmentManager.studentAssignmentMenuStatusOrderArray || [
    ASSIGNMENT_MENU_STATUS.CURRENT,
    ASSIGNMENT_MENU_STATUS.TODAY,
    ASSIGNMENT_MENU_STATUS.CLOSED,
    ASSIGNMENT_MENU_STATUS.GRADED
  ];

  return (
    <div className='StudentAssignmentMenuStatusTabs sa-menu-control'>
      <Menu className='student-menu'>
        {menuStatusOrder.map((status) => (
          <Menu.Item key={status}
            active={activeMenuStatus === status}
            as='button'
            className={classNames(status, {
              [loadingClassName]: loading
            })}
            name={status}
            onClick={onClick}
            tabIndex='0'>
            <div>{t(ASSIGNMENT_MENU_STATUS.getTitle(status))}</div>
          </Menu.Item>
        ))}
      </Menu>
    </div>
  );
});
export default StudentAssignmentMenuStatusTabs;

SatCoreRegister('StudentAssignmentMenuStatusTabs', StudentAssignmentMenuStatusTabs);
